export const LANGUAGES = {
  vi: {
    key: "vi",
    icon: (
      <i className="icon-flag_vi_512x512">
        <span className="path1"></span>
        <span className="path2"></span>
      </i>
    ),
    label: "Việt Nam",
  },
  en: {
    key: "en",
    icon: (
      <i className="icon-flag_en_512x512">
        <span className="path1"></span>
        <span className="path2"></span>
        <span className="path3"></span>
        <span className="path4"></span>
        <span className="path5"></span>
        <span className="path6"></span>
        <span className="path7"></span>
        <span className="path8"></span>
        <span className="path9"></span>
        <span className="path10"></span>
        <span className="path11"></span>
        <span className="path12"></span>
        <span className="path13"></span>
        <span className="path14"></span>
      </i>
    ),
    label: "English",
  },
};
